import { Spacing, SpacingSizes } from "@components/Spacing";
import { useGoals, useTheme } from "@hooks";
import { ShareGoalRouteParams } from "@routes/ShareGoalRoute/types";
import { useLocation } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import { ContributorItem } from "./ContributorItem";

const COLORS_LENGTH = 3;

export const ContributorList = () => {
  const { theme } = useTheme();
  const location = useLocation();
  const { goals } = useGoals();

  const goalId = (location.state as ShareGoalRouteParams).goalId;
  const goal = goals.find((g) => g.id === goalId);
  const partners = goal?.partners ?? [];

  return (
    <>
      {partners.map((partner, index) => {
        const colorIndex = (index % COLORS_LENGTH) + 1;

        if (!partner?.firstName || !partner.id) return null;

        // @ts-expect-error
        const color = theme.contact[`item${colorIndex}`];

        return (
          <Fragment key={`share-contributor-${index}`}>
            <ContributorItem
              color={color}
              firstName={partner.firstName}
              lastName={partner.lastName}
              partnerId={partner.id}
            />
            <Spacing size={SpacingSizes.S} />
          </Fragment>
        );
      })}
    </>
  );
};
